


































































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import UpdateBackOrderStatu from '@/store/entities/back-order-update-statu'
    import UpdateOderStatu from './update-mainlandorder-statu.vue'
    import Weight from './weight-input.vue'
    import EditPackedStastus from './order-packed.vue'
    import moment from 'moment'
    import AddShipment from './order-addshipment.vue'
    import appconst from '@/lib/appconst';
    import EditShipment from './order-editshipment.vue'
    import SupplyWeightPicTure from './supplyweightpicture.vue'
    import Preview from 'vue-photo-preview'
    import ResultNativeModel from '@/store/entities/nationallogisticsnative'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)

    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        packageStatus?: number;
        userCode: string;
        SearchInfo: string;
        WaybillNumber: string;
        packedBeginTime?: Date;
        packedEndTime?: Date;
        BeginTime?: Date;
        EndTime?: Date;
        OrderType?: number;
        PlatformType?: number
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.OrderType = 1;
        }
    }

    @Component({
        name: "backmainlandOrderList",
        components: { UpdateOderStatu, EditPackedStastus, AddShipment, Weight, EditShipment, SupplyWeightPicTure }
    })
    export default class MainLandOrders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        packedTime: Date[] = [];
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        siteType = Enums.getEnum(Enums.ShopSiteType, true);
        Model: Array<ResultNativeModel> = [];
        spinShow: boolean = false;
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        Dispaly: string = "";
        CList: Array<any> = [];
        isLoadPrintList: boolean = false;
        updateOderStatuShow = false;
        editModalShow: boolean = false;
        editShipmentModalShow: boolean = false;
        editSupplyWeightPicTure: boolean = false;
        AddModalShow: boolean = false;
        weightShow: boolean = false;
        pdfModelShow: boolean = false;
        automaticJump: boolean = true;
        Total: number = 0;
        async searchPage() {
            this.$store.state.backmainlandorder.currentPage = 1;
            this.getpage();
        }
        get list() {
            return this.$store.state.backmainlandorder.list;
        };
        get loading() {
            return this.$store.state.backmainlandorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backmainlandorder/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        @Watch('$route.params.inputNativeShipment')
        inputNativeShipmentChange() {
            var s = '';
            if (this.$route.params.inputNativeShipment) {
                this.pagerequest = new PageOrderRequest();
                this.pagerequest.SearchInfo = this.$route.params.inputNativeShipment;
                this.$store.state.backmainlandorder.currentPage = 1;
                this.getpage();
            }

        }
        enter() {
            this.getpage();
        }

        async exportexpress() {
            await this.$store.dispatch({
                type: 'backmainlandorder/impotExcel',
                data: this.pagerequest
            })
        }
        async handleRowClick(row) {
            var _this = this;
            if (row.waybillNumber != null) {
                this.spinShow = true;
                this.Model = await this.$store.dispatch({
                    type: 'backmainlandorder/getlogisticsResult',
                    data: { number: row.waybillNumber }
                }).finally(() => {
                    this.spinShow = false;
                });
                // this.spinShow = false;
                var a = this.Model;
                if (this.Model.length == 0) {
                    this.$Modal.info({
                        title: "提示", content: "没有跟踪信息！", onOk: async () => {
                        }
                    });
                }

                else {

                    var html = "";
                    var tr = "";
                    var table = "<table style='border:1px solid #0094ff;border-collapse:collapse; cellpadding:2;cellspacing:0;'><tr><td style='border:1px solid #0094ff;'>日期时间</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;详细内容</td></tr>";
                    this.Model.forEach(function (item, index) {
                        tr += "<tr><td style='border:1px solid #0094ff;'>" + item.dateTime + "&#12288;&#12288;</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;" + item.content + "</td></tr>";
                    })
                    var endtable = "</table>";
                    html = table + tr + endtable;
                    this.$Modal.info({
                        title: "提示", width: 600, content: html, onOk: async () => {
                        }
                    });

                }



            };


        }

        pagesizeChange(pagesize: number) {
            this.$store.commit('backmainlandorder/setPageSize', pagesize);
            this.getpage();
        }
        async weighing() {
            this.updatePackageStatus(3);
        }
        async cancelpacked() {
            this.updatePackageStatus(8);
        }
        async packed() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
            }
            this.$store.state.backmainlandorder.ids = ids;
            this.$store.state.backorder.ordertype = 1;
            // this.updatePackageStatus(2);
            this.editModalShow = true;
        }
        async pendingWarehouse() {
            this.updatePackageStatus(6);
        }
        async arriveWarehouse() {

            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];

            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].id);
                if (i + 1 < selection.length) {
                    if (selection[i].cargoCategory != selection[i + 1].cargoCategory) {
                        this.$Message.error("选中的数据中货物类别不一致！");
                        return;
                    }
                }
            }

            this.$store.state.backmainlandorder.ids = ids;
            this.$store.state.backorder.ordertype = 1;
            this.$store.state.backmainlandorder.cargoCategory = selection[0].cargoCategory;
            // this.updatePackageStatus(2);
            this.AddModalShow = true;
        }
        async updatePackageStatus(statu: number) {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backmainlandorder/updatePackageStatus',
                        data: { ids: ids, PackageStatus: statu, orderType: this.pagerequest.OrderType }
                    });
                    this.getpage();

                }
            });
        }

        //@Watch('$store.state.backmainlandorder.isPacked')
        //isPackedChange() {
        //    if (this.$store.state.backmainlandorder.isPacked) {
        //        this.$router.push({ name: 'backmainlandOrderList' });
        //    }


        //}
        async getpage() {
            //this.$store.state.backmainlandorder.isPacked = true;
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            if (this.packedTime.length > 0) {
                this.pagerequest.packedBeginTime = this.packedTime[0];
            } else {
                this.pagerequest.packedBeginTime = null;
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.packedEndTime = this.packedTime[1];
            } else {
                this.pagerequest.packedEndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'backmainlandorder/getAll',
                data: this.pagerequest
            });
            this.Total = this.$store.state.backmainlandorder.totalCount;
            var _this: any = this;
            _this.$previewRefresh();
        }

        get pageSize() {
            return this.$store.state.backmainlandorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backmainlandorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backmainlandorder.currentPage;
        }
        async Newpacked(data: any) {
            this.$store.state.backmainlandorder.id = data.id;
            this.$store.state.backmainlandorder.orderNumber = data.orderNumber;
            this.$store.state.backmainlandorder.BaseSkuNums = data.orderProductInfoList.length;
            this.$store.state.backmainlandorder.cargoCategory = data.cargoCategory;
            this.$store.state.backmainlandorder.site = data.site;
            this.$store.state.backmainlandorder.packimgGuid = data.weightImageUploadGuid;
            this.$store.state.backmainlandorder.automaticJump = this.automaticJump;
            this.weightShow = true;
        }

        async operationData(name: any, data: any) {
            //if (name == '查看Pdf') {
            //    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
            //    if (packageStatus != "已收货") {
            //        this.$Modal.confirm({
            //            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
            //                this.$store.commit('fontorder/getPdf', {
            //                    pdfGuid: data.pdfGuid,
            //                    userId: data.userId,
            //                    orderNumber: data.orderNumber
            //                });
            //            }
            //        });
            //    }
            //    else {
            //        this.$store.commit('fontorder/getPdf', {
            //            pdfGuid: data.pdfGuid,
            //            userId: data.userId,
            //            orderNumber: data.orderNumber
            //        });
            //    }
            //}
            if (name == "修改本土包裹") {
                this.$store.state.backmainlandorder.packageName = data.packageName;
                this.$store.state.backmainlandorder.id = data.id;
                this.$store.state.backmainlandorder.cargoCategory = data.cargoCategory;
                this.editShipmentModalShow = true;
            }
            else if (name == "复制订单编号") {
                this.copyInfo(data.orderNumber);
            }
            //else if (name == "称重") {
            //    this.$store.state.backmainlandorder.id = data.id;
            //    this.weightShow = true;
            //}
            else if (name == "复制快递单号") {
                var stringList: Array<string> = [];
                data.logistics.forEach(function (element) {
                    stringList.push(element.shipment);
                });
                this.copyInfo(stringList.join("/"));
            }
            else if (name == '标记为异常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = -1;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                this.$store.state.backmainlandorder.updateOrdeData = updateData;

                this.updateOderStatuShow = true;
            } else if (name == '标记为正常') {
                var updateData = new UpdateBackOrderStatu();
                updateData.id = data.id;
                updateData.orderStatus = 0;
                updateData.reMark = data.warehouseNote;
                updateData.orderNumber = data.orderNumber;
                updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                    this.$store.state.backmainlandorder.updateOrdeData = updateData;
                this.updateOderStatuShow = true;
            } else if (name == '撤销订单') {
                await this.$store.dispatch({
                    type: 'backmainlandorder/cancelOrder',
                    data: { id: data.id }
                });
                this.getpage();
            }
            else if (name == "补充称重图片") {
                this.$store.state.backmainlandorder.orderNumber = data.orderNumber;
                this.editSupplyWeightPicTure = true;
            }
        }

        printPdf(data) {
            var pdfData = {
                pdfGuid: data.pdfGuid,
                userId: data.userId,
                orderNumber: data.orderNumber,
                url: '',
            };
            this.$store.commit('fontmainlandorder/getPdfUrl', pdfData);
            if (pdfData.url && pdfData.url.length > 0) {
                var LODOP = getLodop();
                if (!this.isLoadPrintList) {
                    LODOP.Create_Printer_List(document.getElementById('SelectPrint'));
                    this.$Message.success("已加载打印机，请选择指定打印机");
                    this.isLoadPrintList = true;
                    return;
                }
                var printSelect: any = document.querySelector('#SelectPrint');
                if (!printSelect.value) {
                    this.$Message.success("请选择指定打印机");
                    return;
                }
                LODOP.PRINT_INIT("订单" + data.orderNumber + "打印");
                LODOP.SET_PRINTER_INDEX(printSelect);
                if (pdfData.url.indexOf('https://') != -1) {
                    var base64 = demoDownloadPDF(pdfData.url);
                    LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", base64);
                } else {
                    LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", pdfData.url);
                }
                LODOP.PRINT();
            }
        }



        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }

        JumpToUrl(val: string) {
            window.open(val, '_blank')
        }



        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            },
            {
                title: '订单信息',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "订单编号:" + (params.row.orderNumber == null ? "" : params.row.orderNumber)), h('h3', "用户编号:" + (params.row.userCode == null ? "" : params.row.userCode)), h('h3', "订单站点:" + (Enums.ShopSiteType.filter(function (item) { return item.value == params.row.site })[0].name)), h('h3', "货物类别:" + (Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name)), h('h3', "所属平台:" + (Enums.PlatformType.filter(function (item) { return item.value == params.row.platformType })[0].name))])
                }
            },
            {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '包裹状态',
                width: 120,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name,
                    )
                }
            },
            {
                title: '产品订单状态',
                width: 110,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: 'red' } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            },
            {
                title: '采购订单编号',
                key: 'logistics',
                width: 150,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {
                        return h('li', {
                            domProps: {
                                innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                            }
                        });
                    }));
                }
            },
            //{
            //    title: '订单编号',
            //    key: 'orderNumber',
            //    width: 150,
            //},
            {
                title: '运单号',
                key: 'tradeNo',
                width: 150,
            },
            ////{
            ////    title: '物流方式',
            ////    key: 'shippingMethods',
            ////    width: 150,
            ////},
            //{
            //    title: '用户编号',
            //    key: 'userCode',
            //    width: 90,
            //},
            {
                title: '快递单号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('div', [h('p', "货运单号：" + (params.row.waybillNumber == null ? "暂无" : params.row.waybillNumber)), h('p', "快递单号："), h('ul', params.row.logistics.map(item => {

                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn) {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });
                    }))]
                    )

                }
                //render: (h: any, params: any) => {
                //    return h('ul', params.row.logistics.map(item => {
                //        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                //        var shipment = '';

                //        if (item.shipment) {
                //            shipment = item.shipment;
                //        }
                //        if (item.orderCount > 1) {
                //            shipment = item.shipment + "【" + item.orderCount + "】";
                //        }
                //        if (item.shelfNumber) {
                //            shipment = shipment + "-" + item.shelfNumber;
                //        }
                //        return h('li', {
                //            domProps: {
                //                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + (PackageStatus.color.length > 0 ? "border-left:5px solid " + PackageStatus.color + ";padding-left:5px" : "") + '">' + shipment + '</a>'
                //            }
                //        });
                //    }));
                //}
            },
            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    var a = "";
                    if (params.row.reMark) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    return h('div', [
                        h('ul', params.row.orderProductInfoList.map(item => {
                            var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                            return h('li', {
                            }, [
                                h('img', {
                                    attrs: {
                                        class: "img",
                                        src: item.url,
                                        preview: params.row.id,
                                        "preview-text": params.row.orderNumber + "-" + item.productName
                                    }
                                }), item.productLinkAddress ? (h('a', { on: { click: () => { this.JumpToUrl(item.productLinkAddress) } } }, item.productName)) : item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                        })), h('h4', { style: { color: a } }, "备注：" + (params.row.reMark == null ? "" : params.row.reMark))
                    ])

                }
            },
            //{
            //    title: '备注',
            //    width: 150,
            //    key: 'reMark',
            //},

            //{
            //    title: '货物类别',
            //    width: 90,
            //    key: 'cargoCategory',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
            //    }
            //},
            //{
            //    title: '订单站点',
            //    width: 90,
            //    key: 'site',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
            //    }
            //},

            //{
            //    title: '包裹基本信息',
            //    key: 'id',
            //    width: 250,
            //    render: (h: any, params: any) => {
            //        return h('span', "长：" + (params.row.long == null ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == null ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == null ? "" : params.row.high) + "cm")
            //    }

            //},
            {
                title: '包裹信息',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "长：" + (params.row.long == null ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == null ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == null ? "" : params.row.high) + "cm"), h('h3', "重量重【g】:" + (params.row.heavyWeight == null ? "" : params.row.heavyWeight)), h('h3', "体积重【g】:" + (params.row.bulkyByXGD == null ? "" : params.row.bulkyByXGD)), h('h3', "实际计算重量【g】:" + (params.row.weightByXGD == null ? "" : params.row.weightByXGD))])
                }
            },
            {
                title: '费用',
                width: 200,
                render: (h: any, params: any) => {
                    var a = "";
                    var b = "";
                    var c = "";
                    var d = "";
                    if (params.row.isPay) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    if (params.row.freightCost) {
                        b = 'red';
                    }
                    else {
                        b = 'dark';
                    }
                    if (params.row.extraCost) {
                        c = 'red';
                    }
                    else {
                        c = 'dark';
                    }
                    if (params.row.extraCostDescribe) {
                        d = 'red';
                    }
                    else {
                        d = 'dark';
                    }
                    return h('div', [h('h3', { style: { color: a } }, "是否支付:" + (params.row.isPay ? this.L('是') : this.L('否'))), h('h3', { style: { color: b } }, "运费【积分】:" + (params.row.freightCost == null ? "" : params.row.freightCost)), h('h3', { style: { color: c } }, "额外消费【积分】:" + (params.row.extraCost == null ? "" : params.row.extraCost)), h('h3', { style: { color: d } }, "额外消费说明:" + (params.row.extraCostDescribe == null ? "" : params.row.extraCostDescribe))])
                }
            },
            //{
            //    title: '重量重【g】',
            //    key: 'heavyWeight',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.heavyWeight == null ? "" : params.row.heavyWeight)
            //    }
            //},
            //{
            //    title: '体积重【g】',
            //    key: 'bulkyByXGD',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.bulkyByXGD == null ? "" : params.row.bulkyByXGD)
            //    }
            //},
            //{
            //    title: '实际计算重量【g】',
            //    key: 'weightByXGD',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.weightByXGD == null ? "" : params.row.weightByXGD)
            //    }
            //},
            //{
            //    title: '运费【积分】',
            //    key: 'freightCost',
            //    //className: this.Dispaly,
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        //var _this = this;
            //        //if (params.row.packageStatus == 2) {
            //        //    _this.Dispaly = "demo-table-info-column";
            //        //}
            //        return h('span', params.row.freightCost == 0 ? "" : params.row.freightCost)
            //    }
            //},
            //{
            //    title: '额外消费【积分】',
            //    key: 'extraCost',
            //    width: 120,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.extraCost == 0 ? "" : params.row.extraCost)
            //    }
            //},
            //{
            //    title: '额外消费说明',
            //    width: 200,
            //    key: 'extraCostDescribe',
            //},
            //{
            //    title: '是否支付',
            //    key: 'isPay',
            //    width: 120,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.isPay ? this.L('是') : this.L('否'))
            //    }
            //},
            {
                title: '称重上传图片',
                key: 'weightImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.weightImageUploadGuid) {
                        var data = { imageGuid: params.row.weightImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id + "*",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            }, {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id + "//",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '错误信息',
                key: 'mistakeinfomation',
                width: 150,
            },
            {
                title: '本土包裹名称',
                key: 'packageName',
                width: 200,
            },
            {
                title: '打包人',
                key: 'packedUserName',
                width: 90,
            }, {
                title: '创建时间',
                key: 'createTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },

            //{
            //    title: '货运单号',
            //    key: 'waybillNumber',
            //    width: 120,
            //},

            {
                title: '接收时间',
                key: 'receivedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.receivedTime ? DateUtils.formatLongDate(new Date(params.row.receivedTime)) : '');
                }
            }, {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            }, {
                title: '打包时间',
                key: 'packedTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.packedTime ? DateUtils.formatLongDate(new Date(params.row.packedTime)) : '');
                }
            }, {
                title: '称重时间',
                key: 'weighingTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.weighingTime ? DateUtils.formatLongDate(new Date(params.row.weighingTime)) : '');
                }
            },
            {
                title: '仓库名称',
                key: 'warehouseName',
                width: 150,
            }, {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                    var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    if (params.row.packageStatus == 4) {
                        menu.push("修改本土包裹");
                    }

                    if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                        menu.push("标记为异常");
                    }
                    if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                        menu.push("标记为正常");
                    }
                    if (params.row.orderStatus == 0 && params.row.packageStatus != 4 && params.row.packageStatus != 5) {
                        menu.push("撤销订单");
                    }
                    if (!params.row.weightImageUploadGuid) {
                        menu.push("补充称重图片");





                    }
                    //if (params.row.orderStatus == 0 && params.row.packageStatus ==2) {
                    //    menu.push("称重");
                    //}

                    menu.push("复制订单编号");
                    if (params.row.logistics && params.row.logistics.length > 0) {
                        menu.push("复制快递单号");
                    }
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),

                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )],
                        ),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var _this = this;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                                _this.printPdf(data);
                                            }
                                        });
                                    }
                                    else {
                                        _this.printPdf(data);
                                    }
                                }
                            }
                        }, "打印PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                    if (packageStatus != "已收货") {
                                        this.$Modal.confirm({
                                            title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
                                                this.$store.commit('fontmainlandorder/getPdf', {
                                                    pdfGuid: data.pdfGuid,
                                                    userId: data.userId,
                                                    orderNumber: data.orderNumber
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        this.$store.commit('fontmainlandorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            userId: data.userId,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '68px',
                                height: '30px',
                                display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.Newpacked(data);

                                }
                            }

                        }, "打包")
                    ]);
                }
            }]

        async created() {

            var a = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
            if (a == false) {
                this.columns.splice(14, 1);
            }
            this.getpage();
        }
    }
